import Api from 'app/services/Api'

/**
 * get help center categories
 */
export const getHelpCenterCategories = (
  params: HelpCenterCategoryParams
): Promise<HelpCenterCategoryModel[]> =>
  Api.get('/api/v1/help_center/categories', {
    params: {
      sub_categories: params.needSubCategories
    },
    deserialize: true
  })

/**
 * get help center articles
 */
export const getHelpCenterArticles = ({
  byKeyword,
  byCategory
}: HelpCenterArticlesParams): Promise<HelpCenterPreviewArticlePaginationModel> =>
  Api.get('/api/v1/help_center/articles', {
    params: {
      by_keyword: byKeyword,
      by_category: byCategory
    },
    deserialize: true
  })

/**
 * get help center detail article
 */
export const getHelpCenterArticleDetail = (
  slug: string
): Promise<HelpCenterDetailArticleModel> =>
  Api.get(`/api/v1/help_center/articles/${slug}`, {
    deserialize: true
  })

/**
 * get help center category slugs
 */
export const getHelpCenterCategorySlugs = (): Promise<{
  slugs: { slug: string; sub_categories: { slug: string }[] }[]
}> => Api.get('/api/v1/sitemaps/help_center/category_slugs')

/**
 * get help center article slugs
 */
export const getHelpCenterArticleSlugs = (): Promise<{
  slugs: { slug: string; category_slug: string }[]
}> => Api.get('/api/v1/sitemaps/help_center/article_slugs')
